/**
 * 채널 타입 플랫폼 아이콘 컴포넌트
 * FA4에서 지원하지 않는 플랫폼(TikTok, Discord, Telegram, Bilibili, Chzzk, Soop, X)은
 * 인라인 SVG로 렌더링하고, 나머지는 FontAwesome 4 아이콘 사용
 * 툴팁은 CSS data-tooltip 기반으로 즉시 표시
 */
import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

/* ── TikTok ── */
function TikTokIcon({ size = 14, color = '#010101', style }: IconProps) {
  return (
    <svg viewBox="0 0 448 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M448 209.9a210.1 210.1 0 01-122.8-39.3v178.8A162.6 162.6 0 11185 188.3v89.9a74.6 74.6 0 1052.2 71.2V0h88a121 121 0 00122.8 120.1z" />
    </svg>
  );
}

/* ── Discord ── */
function DiscordIcon({ size = 14, color = '#5865f2', style }: IconProps) {
  return (
    <svg viewBox="0 0 640 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M524.5 69.8a1.5 1.5 0 00-.8-.7A485.1 485.1 0 00404.1 32a1.8 1.8 0 00-1.9.9 338 338 0 00-14.9 30.6 447.8 447.8 0 00-134.4 0 309.5 309.5 0 00-15.1-30.6 1.9 1.9 0 00-1.9-.9A483.7 483.7 0 00116.1 69.1a1.7 1.7 0 00-.8.7C39.1 183.7 18.2 294.7 28.4 404.4a2 2 0 00.8 1.4A487.7 487.7 0 00176 479.9a1.9 1.9 0 002.1-.7A348.2 348.2 0 00208.1 430.4a1.9 1.9 0 00-1-2.6 321.2 321.2 0 01-45.9-21.9 1.9 1.9 0 01-.2-3.1c3.1-2.3 6.2-4.7 9.1-7.1a1.8 1.8 0 011.9-.3c96.2 43.9 200.4 43.9 295.5 0a1.8 1.8 0 011.9.2c2.9 2.4 6 4.9 9.1 7.2a1.9 1.9 0 01-.1 3.1 301.2 301.2 0 01-46 21.8 1.9 1.9 0 00-1 2.6 391.1 391.1 0 0030 48.8 1.9 1.9 0 002.1.7A486 486 0 00610.7 405.7a1.9 1.9 0 00.8-1.4C623.7 277.6 590.9 167.5 524.5 69.8zM222.5 337.6c-29 0-52.8-26.6-52.8-59.2s23.4-59.2 52.8-59.2c29.7 0 53.3 26.8 52.8 59.2 0 32.6-23.4 59.2-52.8 59.2zm195.4 0c-29 0-52.8-26.6-52.8-59.2s23.4-59.2 52.8-59.2c29.7 0 53.3 26.8 52.8 59.2 0 32.6-23.1 59.2-52.8 59.2z" />
    </svg>
  );
}

/* ── Telegram ── */
function TelegramIcon({ size = 14, color = '#229ed9', style }: IconProps) {
  return (
    <svg viewBox="0 0 496 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z" />
    </svg>
  );
}

/* ── Bilibili ── */
function BilibiliIcon({ size = 14, color = '#00AEEC', style }: IconProps) {
  return (
    <svg viewBox="0 0 512 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M488.6 104.1c16.7 18.1 24.4 39.7 23.3 65.7v202.4c-.4 26.4-9.2 48.1-26.5 65.1-17.2 17-39.1 25.9-65.5 26.7H92.02c-26.45-.8-48.21-9.8-65.28-27.2C9.682 419.4.767 397.8 0 371.3V169.9c.767-26 8.745-47.7 23.33-65.7 14.59-18 34.1-27.47 58.57-28.39l-15.2-15.18C57.2 51.13 51.73 38.48 51.73 23.97 51.73 9.467 66.77-.053 81.84-.053c8.58 0 15.18 2.928 19.84 8.8l45.82 45.96h118.9l45.8-45.96c4.7-5.87 11.3-8.8 19.8-8.8 15.1 0 30.2 9.52 30.2 24.023 0 14.51-5.5 27.16-15 36.68l-15.2 15.19c24.5.92 44 10.39 58.6 28.39zM185.3 309.3c0 12.8 10.5 23.3 23.3 23.3h95.3c12.8 0 23.3-10.5 23.3-23.3V286c0-12.8-10.5-23.3-23.3-23.3h-95.3c-12.8 0-23.3 10.5-23.3 23.3v23.3zm-46.5-69.8c-17.1 0-30.9 13.8-30.9 30.9 0 17.1 13.8 30.9 30.9 30.9 17.1 0 30.9-13.8 30.9-30.9 0-17.1-13.8-30.9-30.9-30.9zm232.8 0c-17.1 0-30.9 13.8-30.9 30.9 0 17.1 13.8 30.9 30.9 30.9 17.1 0 30.9-13.8 30.9-30.9 0-17.1-13.8-30.9-30.9-30.9z" />
    </svg>
  );
}

/* ── X (Twitter) ── */
function XTwitterIcon({ size = 14, color = '#000000', style }: IconProps) {
  return (
    <svg viewBox="0 0 512 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8l164.9-188.5L26.8 48h145l100.5 132.9L389.2 48zm-24.8 373.8h39.1L151.1 88h-42L364.4 421.8z" />
    </svg>
  );
}

/* ── Chzzk (PNG 아이콘) ── */
function ChzzkIcon({ size = 14, style }: IconProps) {
  return (
    <img
      src="/assets/icons/chzzk.png"
      alt="Chzzk"
      width={size}
      height={size}
      style={{ verticalAlign: 'middle', borderRadius: 3, ...style }}
    />
  );
}

/* ── Soop (AfreecaTV, 원본 icomoon e906 글리프 기반) ── */
function SoopIcon({ size = 14, color = '#0545b1', style }: IconProps) {
  return (
    <svg viewBox="0 0 1024 1024" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M702 696c-73.9 0-140.2-32.1-186.1-83.3a5.3 5.3 0 00-7.3 0C462.6 663.9 396.2 696 322 696c-138.1 0-250-112-250-250s112-250 250-250c74 0 140.4 32.1 186.4 83.4a5.3 5.3 0 007.3 0C561.6 228.1 628 196 702 196c138.1 0 250 112 250 250S840.1 696 702 696zM702 316c-40 0-73.4 19.3-93.9 41l-23.6 24.6c-4.1 3.7-8.3 7.2-12.5 10.4-16.5 11.9-37.2 19-59.5 19h-.6c-22.4 0-43.1-7.1-60-19.2-4.6-3.5-8.7-6.9-12.5-10.4l-23.5-24.6c-20.5-21.7-53.9-41-93.9-41-71.7 0-130 58.3-130 130s58.3 130 130 130c40 0 73.4-19.3 93.9-41l23.5-24.6c4.1-3.7 8.3-7.2 12.5-10.4 16.5-11.9 37.2-19 59.5-19h.6c22.4 0 43.1 7.1 60 19.2 4.6 3.5 8.7 6.9 12.5 10.4l23.6 24.6c20.5 21.7 53.9 41 93.9 41 71.7 0 130-58.3 130-130s-58.3-130-130-130z" />
    </svg>
  );
}

/* ── YouTube ── */
function YouTubeIcon({ size = 14, color = '#FF0000', style }: IconProps) {
  return (
    <svg viewBox="0 0 576 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6C14.9 167 14.9 256 14.9 256s0 89 11.4 131.9c6.3 23.7 24.8 42.3 48.3 48.6C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.9 48.3-48.6C561.1 345 561.1 256 561.1 256s0-89-11.4-131.9zM232 337.7V174.3L374.9 256 232 337.7z" />
    </svg>
  );
}

/* ── Twitch ── */
function TwitchIcon({ size = 14, color = '#6441A4', style }: IconProps) {
  return (
    <svg viewBox="0 0 512 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M391.2 103.5H352.5v109.7h38.7zM285 103.5h-38.7v109.7H285zm-156.2-68L44.3 120v328.3h109.7V533l84.5-84.5h75.1L487.7 275V35.5zm328.3 222.7l-75.1 75.1h-75.1l-65.8 65.8v-65.8h-84.5V73.2h300.5z" />
    </svg>
  );
}

/* ── Facebook ── */
function FacebookIcon({ size = 14, color = '#38589b', style }: IconProps) {
  return (
    <svg viewBox="0 0 448 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M400 32H48A48 48 0 000 80v352a48 48 0 0048 48h137.3V327.7h-63V256h63v-54.6c0-62.2 37-96.5 93.7-96.5 27.1 0 55.5 4.8 55.5 4.8v61h-31.3c-30.8 0-40.4 19.1-40.4 38.7V256h68.8l-11 71.7h-57.8V480H400a48 48 0 0048-48V80a48 48 0 00-48-48z" />
    </svg>
  );
}

/* ── Instagram ── */
function InstagramIcon({ size = 14, color = '#bd1972', style }: IconProps) {
  return (
    <svg viewBox="0 0 448 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
    </svg>
  );
}

/* ── Steam ── */
function SteamIcon({ size = 14, color = '#495057', style }: IconProps) {
  return (
    <svg viewBox="0 0 496 512" width={size} height={size} style={{ verticalAlign: 'middle', ...style }}>
      <path fill={color} d="M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.1-32.1 71.1-71.4l83.1-60.3c59.3 0 108.1-48.3 108.1-108.4S386.4 71.2 328 71.2c-59.8 0-108.4 48.7-108.4 108.1l-59.5 83.8c-1.2-.1-2.4-.1-3.7-.1-18 0-34.4 6.7-46.9 17.8L0 236.6C10.6 108.6 119.5 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.8 52.8 0 0027.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.2 19.8-31 29.1-50.8 20.9zm218.8-176.4c0-40.8-33.3-73.7-73.7-73.7-40.8 0-73.7 33.3-73.7 73.7 0 40.8 33.3 73.7 73.7 73.7 40.4 0 73.7-33.3 73.7-73.7zm-132.8 0c0-32.6 26.5-59.1 59.1-59.1s59.1 26.5 59.1 59.1-26.5 59.1-59.1 59.1-59.1-26.5-59.1-59.1z" />
    </svg>
  );
}

const CHANNEL_COLORS: Record<string, string> = {
  youtube: '#FF0000',
  twitch: '#6441A4',
  tiktok: '#010101',
  facebook: '#38589b',
  instagram: '#bd1972',
  twitter: '#000000',
  steam_curator: '#495057',
  discord: '#5865f2',
  telegram: '#229ed9',
  bilibili: '#00AEEC',
  chzzk: '#00ffa3',
  afreeca: '#0545b1',
};

const CHANNEL_TITLES: Record<string, string> = {
  youtube: 'YouTube',
  twitch: 'Twitch',
  tiktok: 'TikTok',
  facebook: 'Facebook',
  instagram: 'Instagram',
  twitter: 'X (Twitter)',
  steam_curator: 'Steam curator',
  discord: 'Discord',
  telegram: 'Telegram',
  bilibili: 'Bilibili',
  chzzk: 'Chzzk',
  afreeca: 'Soop',
  ambassador: 'Ambassador',
};

type SvgRenderer = (props: IconProps) => React.JSX.Element;

const SVG_ICONS: Record<string, SvgRenderer> = {
  youtube: YouTubeIcon,
  twitch: TwitchIcon,
  tiktok: TikTokIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  twitter: XTwitterIcon,
  steam_curator: SteamIcon,
  discord: DiscordIcon,
  telegram: TelegramIcon,
  bilibili: BilibiliIcon,
  chzzk: ChzzkIcon,
  afreeca: SoopIcon,
};

/**
 * 채널 타입에 해당하는 아이콘을 렌더링
 * 모든 아이콘은 인라인 SVG 또는 PNG로 렌더링 (FontAwesome 의존 없음)
 */
export default function ChannelTypeIcon({
  type,
  size = 14,
  style,
}: {
  type: string;
  size?: number;
  style?: React.CSSProperties;
}) {
  const color = CHANNEL_COLORS[type] ?? 'inherit';
  const tooltip = CHANNEL_TITLES[type] ?? type;

  const SvgComponent = SVG_ICONS[type];
  if (SvgComponent) {
    return (
      <span data-tooltip={tooltip} style={{ display: 'inline-flex', ...style }}>
        <SvgComponent size={size} color={color} />
      </span>
    );
  }

  return (
    <span
      style={{ fontSize: size, color, verticalAlign: 'middle', fontWeight: 600, ...style }}
      data-tooltip={tooltip}
    >
      {type}
    </span>
  );
}
